import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  createSelectedAssetsSet,
  getSelectionState,
  getHierarchicalSelection,
} from './checkboxHelper';
import { MenuTreeItem } from '@shape-ds/components';

export const useOptimizedAssetSelection = (item: MenuTreeItem) => {
  const { setValue, watch } = useFormContext();

  const watchedAssets = watch('assets');
  const selectedAssets = useMemo(() => watchedAssets ?? [], [watchedAssets]);

  const selectedAssetsSet = useMemo(
    () => createSelectedAssetsSet(selectedAssets),
    [selectedAssets],
  );

  const selectionState = useMemo(
    () => getSelectionState(item, selectedAssetsSet),
    [item, selectedAssetsSet],
  );

  const toggleSelection = useMemo(() => {
    return () => {
      const newAssets = getHierarchicalSelection(item, selectedAssets);
      setValue('assets', newAssets, { shouldDirty: true });
    };
  }, [setValue, selectedAssets, item]);

  return {
    ...selectionState,
    toggleSelection,
    selectedAssets,
  };
};
